// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable no-restricted-imports, func-names, new-cap, babel/new-cap */
// FIXME: remove this disable directive and fix the ESLint error(s)

import _ from "lodash"
import { List, Map } from "immutable"
import cuckoo from "@kiwicom/frontend-common/services/cuckoo/cuckoo"
import mapperJourney from "@kiwicom/frontend-common/services/journey/mapperJourney"
import { cuckooEvents } from "@kiwicom/frontend-common/consts/enums"

export default function (input, airlines) {
  try {
    return _.reduce(
      input,
      (acc, item) =>
        // FIXME: a method has been detected that possibly mutates the object, consider a more
        // functional approach (Ramda might help)

        acc.push(
          Map({
            journey: mapperJourney(_.omit(item, "segments_to_order"), "", false, airlines),
            segmentToChange: item.segments_to_order, // Weird naming
          }),
        ),
      List(),
    )
  } catch (err) {
    cuckoo.error(cuckooEvents.INTERNAL_MAPPER_PENDING_FLIGHT_CHANGE_OPTIONS_UNSUPPORTED_FORMAT, {
      input,
      err,
    })
    return null
  }
}
